import React, { Component } from "react";
import Familymember from "./Familymember/Familymember";
import House from "./House/House";
import Personaldetails from "./Personaldetails/Personaldetails";
import "./Profile.scss";
import Vehicles from "./Vehicles/Vehicles";
interface Props {
  pageStatus: string;
}

const Profile: React.FC<Props> = ({ pageStatus }) => {
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const [addMemberStatus, setAddMemberStatus] = React.useState(false);
  const [vehiclesstatus, setVehiclesStatus] = React.useState(false);
  return (
    <div>
      {pageStatus === "personalDetails" ? (
        <Personaldetails
          attrName={setAddMemberStatus}
          open_status={addMemberStatus}
          value_update={updateMasterState}
        />
      ) : null}
      {pageStatus === "family" ? <Familymember /> : null}
      {pageStatus === "vehicles" ? (
        <Vehicles
          attrName={setVehiclesStatus}
          open_status={vehiclesstatus}
          value_update={updateMasterState}
        />
      ) : null}
      {pageStatus === "house" ? <House /> : null}
    </div>
  );
};

export default Profile;
